import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlusSquare, faTimes} from "@fortawesome/free-solid-svg-icons";
import {useAlert} from "react-alert";
import {joinProp} from "../../../shared/utils/helpers";
import {forEach} from "react-bootstrap/ElementChildren";

const Attributes = ({formData, setFormData}) => {
    let reactAlert = useAlert(null);

    const onRemove = (index) => {
        setFormData({...formData, attributes: formData.attributes.filter((attr, i) => i !== index)});
    }

    const onChangeEffectOnPrice = (e, index) => {
       let attr = formData.attributes[index];
       let previousValChecked = attr['effect_on_price'];
        if (!previousValChecked && (
                parseInt(formData.attributes[index]['type']) !== 4
                &&
                parseInt(formData.attributes[index]['type']) !== 3
                )
            ) {
            reactAlert.error('توجه! فقط ویژگی های لیستی می توانند تاثیر گذار بر قیمت باشند.');
            e.preventDefault();
            return;
        }


        setFormData({...formData, attributes: formData.attributes.map((attribute, i) => {
            let tempAttr = attribute;
            if (i !== index) {
                tempAttr['effect_on_price'] = false;
            } else {
                tempAttr['effect_on_price'] = true;
            }

            return tempAttr;
        })});
    }

    const onChangeOptionValue = (index, name, val) => {
        setFormData({...formData, attributes: formData.attributes.map((attribute, i) => {
            if (i !== index) {
                return attribute;
            } else {
                let tempAttr = attribute;
                tempAttr[name] = val;
                return tempAttr;
            }
        })});
    }

    const onChangeOptions = (index, optionIndex, val) => {
        let newAttributeValue = formData.attributes.map((attribute, i) => {
            if (i === index) {
                return {...attribute, options:
                        attribute.options.map((option, i2) => i2 === optionIndex ? {...option, value: val} : option) }
            } else {
                return attribute;
            }
        });

        setFormData({...formData, attributes: newAttributeValue});
    }

    const onAddOption = (index) => {
        let emptyOption = {value: ''};
        setFormData({...formData, attributes: formData.attributes.map((attribute, i) => {
            return index === i ?
                {...attribute, options: [...attribute.options, emptyOption] }
                :
                attribute;
        }) });
    }

    const onRemoveOption = (index, optionIndex) => {
        let newAttributeValue = formData.attributes.map((attribute) => {
            return {...attribute, options:
                    attribute.options.filter((option, i) => i !== optionIndex )};
        });

        setFormData({...formData, attributes: newAttributeValue});
    }

    return (
        formData.attributes.map((attribute, index) => (
            <div className="row mb-2 mt-3 align-items-end">
                <div className="col-auto">
                    <label htmlFor={`effect_on_price${index}`}>تاثیر گذار قیمت</label>
                    <input type="radio"
                           checked={attribute.effect_on_price}
                           onClick={(e) =>
                               onChangeEffectOnPrice(e, index)}
                           className="form-control" id={`effect_on_price${index}`} name="effect"/>
                </div>
                <div className="col-auto">
                    <label>نوع</label>
                    <select className="form-control"
                            value={attribute.type}
                            onChange={(e) =>
                                onChangeOptionValue(index, 'type', e.target.value)}>
                        <option value="1">متنی</option>
                        <option value="2">تاریخ</option>
                        <option value="3">رنگ</option>
                        <option value="4">لیست</option>
                    </select>
                </div>
                <div className="col-auto">
                    <label>نام</label>
                    <input type="text"
                           value={attribute.name}
                           onChange={(e) =>
                           onChangeOptionValue(index, 'name', e.target.value)}
                           className="form-control"/>
                </div>
                <div className={`col ${parseInt(attribute.type) !== 4 ? 'invisible' : '' }`}>
                    <label>تعریف مقادیر</label>
                    <span className="add-option text-success d-inline-block mr-2"
                    onClick={() => onAddOption(index)}>
                        <FontAwesomeIcon icon={faPlusSquare} size="lg"/>
                    </span>
                    <br />
                    {attribute.options.map((option, i) => (
                        <>
                            <input type="text" value={option.value}
                                   onChange={(e) => onChangeOptions(index, i, e.target.value)}
                                   className="form-control option-text-box"/>
                            <span className="text-danger ml-3"
                                  onClick={(e) => onRemoveOption(index, i)}
                            ><FontAwesomeIcon icon={faTimes} /></span>
                        </>
                    ))}

                </div>
                <div className="col-auto pl-5">
                    <span className="text-danger"
                          onClick={() => onRemove(index)}
                          style={{ fontSize: '1.1rem'}}>
                        <FontAwesomeIcon icon={faTimes} size="lg"/>
                    </span>
                </div>
            </div>
        ))
    )
}

export default Attributes;
